import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Lock, CreditCard, Check } from "lucide-react";

const defaultPlans = [
  { id: "basic", name: "Basic", price: 29, features: ["Sistema operativo básico", "Actualizaciones mensuales", "Soporte por email"] },
  { id: "pro", name: "Pro", price: 59, features: ["Sistema operativo completo", "Seguridad avanzada", "Soporte prioritario 24/7"] },
  { id: "enterprise", name: "Enterprise", price: 199, features: ["Sistema personalizado", "Licencias ilimitadas", "Soporte 24/7 dedicado"] }
];

const CheckoutModal = ({ isOpen, onClose, planId, plans, onCheckout }) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const planList = plans || defaultPlans;
  const plan = planList.find(p => p.id === planId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setIsLoading(true);
    await onCheckout(email);
    setIsLoading(false);
  };

  if (!plan) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
        >
          <div 
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={onClose}
          />

          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            data-testid="checkout-modal"
            className="relative glass-card w-full max-w-md p-8"
          >
            <button
              data-testid="checkout-close"
              onClick={onClose}
              className="absolute top-4 right-4 text-[#94a3b8] hover:text-white transition-colors"
            >
              <X className="w-6 h-6" />
            </button>

            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-[#3b82f6]/20 flex items-center justify-center mx-auto mb-4">
                <CreditCard className="w-8 h-8 text-[#3b82f6]" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2">
                Plan {plan.name}
              </h3>
              <p className="text-4xl font-bold text-white">
                ${plan.price}
                <span className="text-[#94a3b8] text-lg font-normal">/mes</span>
              </p>
            </div>

            <div className="mb-8 space-y-2">
              {plan.features.map((feature, i) => (
                <div key={i} className="flex items-center gap-2">
                  <Check className="w-4 h-4 text-[#3b82f6]" />
                  <span className="text-[#94a3b8] text-sm">{feature}</span>
                </div>
              ))}
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-6">
                <label className="block text-[#94a3b8] text-sm mb-2">
                  Email para la factura
                </label>
                <input
                  type="email"
                  data-testid="checkout-email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="contact-input w-full"
                  placeholder="tu@email.com"
                />
              </div>

              <button
                type="submit"
                data-testid="checkout-submit"
                disabled={isLoading}
                className="btn-primary w-full flex items-center justify-center gap-2"
              >
                {isLoading ? (
                  <span>Procesando...</span>
                ) : (
                  <>
                    <Lock className="w-4 h-4" />
                    <span>Pagar con Stripe</span>
                  </>
                )}
              </button>
            </form>

            <p className="text-[#94a3b8] text-xs text-center mt-4">
              <Lock className="w-3 h-3 inline mr-1" />
              Pago seguro procesado por Stripe
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CheckoutModal;
